import styled from 'styled-components';

// Mobile Collapsed Search
export const SearchCollapsed = styled.div`
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255,255,255,0.05)'
      : 'rgba(255,255,255,0.95)'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.08)'};
  padding: 12px;
  border-radius: 12px;
  display: none;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    display: flex;
    margin: 0 8px 16px 8px;
    width: calc(100% - 16px);
  }

  &:hover {
    background: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.08)'
        : 'rgba(255,255,255,1)'};
  }

  svg {
    width: 20px;
    height: 20px;
    color: ${props => props.theme?.colors?.primary || '#fa4616'};
  }

  span {
    color: ${(props) => (props.theme.name === 'dark' ? '#94A3B8' : '#64748b')};
    font-size: 14px;
  }
`;

export const SearchExpanded = styled.div`
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255,255,255,0.08)'
      : 'rgba(255,255,255,1)'};
  border: 1px solid ${props => props.theme?.colors?.primary || '#fa4616'};
  padding: 0;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  margin-bottom: 16px;
  display: none;
  position: relative;

  @media (max-width: 768px) {
    display: block;
    margin: 0 8px 16px 8px;
    width: calc(100% - 16px);
  }
`;

export const SearchExpandedInput = styled.input`
  width: 100%;
  padding: 14px 16px;
  background: none;
  border: none;
  color: ${(props) => (props.theme.name === 'dark' ? 'white' : props.theme.colors.blueBlack)};
  font-size: 15px;
  outline: none;

  &::placeholder {
    color: ${(props) => (props.theme.name === 'dark' ? '#94A3B8' : '#64748b')};
  }
`;

export const SearchCard = styled.div`
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255,255,255,0.05)'
      : 'rgba(255,255,255,0.95)'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.08)'};
  border-radius: 8px;
  box-shadow: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(0, 0, 0, 0.1) 0px 1px 3px'
      : 'rgba(0, 0, 0, 0.05) 0px 1px 3px'};
  padding: 16px;
  transition: box-shadow 0.15s ease;
  font-family: Arial, -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Ubuntu, sans-serif;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    display: none; /* Hide desktop search on mobile */
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  width: 100%;

  @media (max-width: 768px) {
    gap: 8px;
  }
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const ClearButton = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  transition: color 0.15s ease;
  z-index: 1;

  &:hover {
    color: ${props => props.theme?.colors?.primary || '#fa4616'};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 12px 16px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255,255,255,0.05)'
      : 'rgba(255,255,255,1)'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.15)'};
  border-radius: 8px;
  color: ${(props) => (props.theme.name === 'dark' ? '#ffffff' : '#334155')};
  font-size: 14px;
  transition: all 0.15s ease;

  &::placeholder {
    color: ${(props) => (props.theme.name === 'dark' ? '#94A3B8' : '#64748b')};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.theme?.colors?.primary || '#fa4616'};
    background: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.05)'
        : 'rgba(255,255,255,1)'};
    box-shadow: ${(props) =>
      props.theme.name === 'dark'
        ? `0 0 0 1px ${props.theme?.colors?.primary || '#FA4616'}`
        : '0 0 0 3px rgba(250,70,22,0.1)'};
  }
`;

export const SearchButton = styled.button`
  padding: 12px 24px;
  background: ${props => props.theme?.colors?.primary || '#fa4616'};
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: #e63e13;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(250, 70, 22, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const FilterPills = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 12px;

  @media (max-width: 768px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 8px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const MobileFilterPills = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    gap: 8px;
    margin: 0 8px 16px 8px;
    width: calc(100% - 16px);
    overflow-x: auto;
    padding-bottom: 8px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const FilterPill = styled.button`
  padding: 8px 16px;
  background: ${(props) => {
    if (props.active) {
      return 'rgba(250,70,22,0.08)';
    }
    return props.theme.name === 'dark'
      ? 'rgba(255,255,255,0.06)'
      : 'rgba(255,255,255,1)';
  }};
  border: 1px solid
    ${(props) => {
      if (props.active) {
        return props.theme?.colors?.primary || '#FA4616';
      }
      return props.theme.name === 'dark'
        ? props.theme?.colors?.['border-button'] || 'rgba(255,255,255,0.15)'
        : 'rgba(0,0,0,0.15)';
    }};
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => {
    if (props.active) {
      return props.theme?.colors?.primary || '#FA4616';
    }
    return props.theme.name === 'dark'
      ? props.theme?.colors?.textGray?.secondary || '#94a3b8'
      : props.theme?.colors?.textGray?.muted || '#64748b';
  }};
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    ${(props) =>
      !props.active &&
      `
      background: rgba(250,70,22,0.08);
      color: ${props.theme?.colors?.primary || '#FA4616'};
      border-color: ${props.theme?.colors?.primary || '#FA4616'};
    `}
  }
`;
